export default "/react/google_internal-a3657bb0.svg";